import { createReducer } from '@reduxjs/toolkit';
import { PackShape } from './model';
import * as packActions from './actions';
import { applyTotal, EMPTY_TOTAL, Loading } from '../finder/model';

const initial: PackShape = {
  data: { assets: [], total: EMPTY_TOTAL, asset_ids: [] },
  loading: Loading.none,
  hasNextPage: false,
  scrollHash: '',
  inProgress: {},
  allInProgress: false,
  relatedSharing: undefined,
  relatedSharingInProgress: false,
};

export const packReducer = createReducer<PackShape>(initial, (builder) =>
  builder
    .addCase(packActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(packActions.assetsChanged, (s, a) => {
      s.data.assets = a.payload.data.assets;
      s.data.asset_ids = a.payload.data.asset_ids ?? s.data.asset_ids;
      applyTotal(s.data.total, a.payload.data.total);

      s.hasNextPage = a.payload.hasNextPage;
      s.scrollHash = a.payload.scrollHash;
    })
    .addCase(packActions.thumbnailUpdated, (s, a) => {
      s.data.assets = s.data.assets.map((asset) =>
        asset.id === a.payload.assetId ? { ...asset, thumbnail_url: a.payload.url } : asset,
      );
    })
    .addCase(packActions.setAllInProgress, (s, a) => {
      s.allInProgress = a.payload.allInProgress;
    })
    .addCase(packActions.setInProgress, (s, a) => {
      if (a.payload.inProgress) {
        a.payload.ids.forEach((id) => {
          s.inProgress[id] = true;
        });
      } else {
        a.payload.ids.forEach((id) => {
          delete s.inProgress[id];
        });
      }
    })
    .addCase(packActions.setRelatedSharing, (s, a) => {
      s.relatedSharing = a.payload.relatedSharing;
    })
    .addCase(packActions.setRelatedSharingInProgress, (s, a) => {
      s.relatedSharingInProgress = a.payload.inProgress;
    }),
);
